export default {
    api: 'https://zelraiback.promicom.xyz/api/',
    currency_courses: {
        'usd_byn': 2.95
    }
}